var _defs, _tspan, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTs68(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "51.901554mm",
    height: "132.29167mm",
    viewBox: "0 0 51.901554 132.29167",
    id: "svg94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-4.1126392e-8,-164.70834)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 117.83928,
    id: "text98"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan100",
    x: 16.630953,
    y: 127.62886
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 111.03571,
    id: "text104"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan102",
    x: 16.630953,
    y: 158.02571,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      strokeWidth: 0.26458332
    }
  })), /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\uF5F0",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "120.26547241px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.62638098
    },
    id: "text108",
    transform: "matrix(1.3613824,0,0,1.3613824,-2.619638,-105.38925)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 25.015219,212.95163 c 1.202655,1.20265 2.766106,1.68371 4.329557,1.68371 0.721593,0 1.683717,-0.24053 2.40531,-0.48106 3.006636,-0.72159 5.29168,-3.84849 5.29168,-6.85513 0,-0.3608 0,-0.72159 -0.120265,-1.08239 -0.481062,-3.1269 -3.126902,-5.53221 -6.013274,-6.49434 -2.285044,-0.96212 -5.171415,-1.32292 -7.576724,-1.32292 -7.336194,0.12027 -14.1913262,3.72823 -17.6790249,10.22257 -2.044513,4.08903 -3.7282296,9.14017 -3.7282296,13.71026 v 0.3608 c 0.1202654,4.44982 0.8418583,9.38071 3.0066368,13.2292 2.044513,3.72823 5.2916807,7.57673 9.0199107,9.26044 2.405309,1.08239 5.29168,1.32292 7.69699,1.32292 4.329557,0 9.140176,-0.60132 12.627875,-3.4877 3.367433,-2.64584 5.532211,-6.97539 5.532211,-11.30495 0,-5.41195 -2.886371,-8.65911 -5.893008,-10.94416 -2.64584,-1.92425 -5.652477,-3.00664 -8.659114,-3.00664 -3.006637,0 -6.253804,1.20266 -8.659114,3.36744 -0.240531,0.24053 -0.481062,0.24053 -0.601327,0.24053 -0.601328,0 -0.841859,-0.84186 -0.841859,-2.40531 0.240531,-17.79929 5.893009,-18.28035 7.937522,-18.28035 1.924247,0 3.126902,0.48106 3.126902,1.44318 0,1.44319 -1.803982,2.52558 -2.40531,3.72823 -0.481061,0.84186 -0.601327,1.80399 -0.601327,2.76611 0,1.44318 0.481062,2.88637 1.443186,3.96876 0.120265,0.12027 0.240531,0.24053 0.360796,0.3608 z m -3.607964,9.3807 c 3.006637,0 5.652477,4.81062 5.652477,10.8239 0,6.01327 -2.64584,10.82389 -5.652477,10.82389 -3.126902,0 -5.652477,-4.81062 -5.652477,-10.82389 0,-6.01328 2.525575,-10.8239 5.652477,-10.8239 z m 10.703627,44.85902 c 3.487699,-2.16477 5.772743,-5.41194 5.772743,-10.22256 0,-9.7415 -14.071061,-11.18469 -16.716901,-11.18469 -11.1846889,0 -18.7614136,5.05115 -18.7614136,13.10894 0,6.73486 3.7282296,10.22256 8.4185826,12.8684 -5.0511494,2.40531 -8.8996445,5.53221 -8.8996445,11.66575 0,8.29832 8.6591135,12.14682 18.1600865,12.14682 9.621238,0 19.964068,-4.08903 19.964068,-17.0777 0,-5.77274 -3.367433,-9.01991 -7.937521,-11.30496 z M 19.723538,292.4471 c -6.494335,0 -12.2670778,-3.24716 -12.2670778,-9.50097 0,-3.84849 3.3674328,-7.45646 7.5767248,-9.14017 6.975397,3.1269 14.07106,5.17141 14.07106,11.54548 0,3.8485 -2.886371,7.09566 -9.380707,7.09566 z m 7.45646,-27.42052 c -7.696991,-2.76611 -15.875043,-4.32956 -15.875043,-10.4631 0,-3.96876 5.411947,-6.01327 9.621238,-6.01327 3.126902,0 11.304955,1.56345 11.304955,8.29831 0,3.8485 -1.924248,6.37407 -5.05115,8.17806 z",
    id: "path4587"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTs68);
export default __webpack_public_path__ + "static/media/ts-6-8.8e4383c5e9c77c53f25d5d9e9a251e57.svg";
export { ForwardRef as ReactComponent };